import { createStore, createActionsHook, createStateHook } from 'react-sweet-state';

const Store = createStore({
	initialState: {
		isBulkReadInProgress: false,
		isBulkResolveInProgress: false,
	},
	actions: {
		setIsBulkReadInProgress:
			(isBulkReadInProgress: boolean) =>
			({ setState }) =>
				setState({
					isBulkReadInProgress,
				}),
		setIsBulkResolveInProgress:
			(isBulkResolveInProgress: boolean) =>
			({ setState }) =>
				setState({
					isBulkResolveInProgress,
				}),
	},
});

export const useCommentBulkOperationsState = createStateHook(Store);
export const useCommentBulkOperationsActions = createActionsHook(Store);
